import { render, staticRenderFns } from "./ProfileGGSeal.vue?vue&type=template&id=74914394&"
import script from "./ProfileGGSeal.vue?vue&type=script&lang=js&"
export * from "./ProfileGGSeal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74914394')) {
      api.createRecord('74914394', component.options)
    } else {
      api.reload('74914394', component.options)
    }
    module.hot.accept("./ProfileGGSeal.vue?vue&type=template&id=74914394&", function () {
      api.rerender('74914394', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/profile/ProfileGGSeal.vue"
export default component.exports